import { render, staticRenderFns } from "./LkStub.vue?vue&type=template&id=3ffe6342&scoped=true&"
import script from "./LkStub.vue?vue&type=script&lang=js&"
export * from "./LkStub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffe6342",
  null
  
)

export default component.exports